// @ts-check
import { Component } from '@verndale/core';
import { rovingIndex } from '@verndale/roving-ux';
// eslint-disable-next-line import/no-cycle
import { loadAsyncModules } from '../modules-utils';

class Module extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $tabContainer: this.el.querySelector('.tabbed-content__tabs-list'),
      $tabs: this.el.querySelectorAll('.tabbed-content__tab'),
      $tabPanels: this.el.querySelectorAll('.tabbed-content__tabpanel'),
      $select: this.el.querySelector('.tabbed-content__tabs-select'),
      $selectOptions: this.el
        .querySelector('.tabbed-content__tabs-select')
        .querySelectorAll('option')
    };

    this.activateTab(this.dom.$tabs[0].id);
    this.setRovings();
  }

  addListeners() {
    this.dom.$tabs.forEach((tab) =>
      tab.addEventListener('click', (e) => {
        this.activateTab(e.currentTarget.id);
      })
    );

    this.dom.$select.addEventListener('change', (e) => {
      this.activateTab(e.target.value);
    });
  }

  activateTab(tabID) {
    const activeTab = [...this.dom.$tabs].find((tab) => tab.id === tabID);
    const controls = activeTab.getAttribute('aria-controls');

    [...this.dom.$selectOptions].forEach((option) => {
      if (option.value === tabID) {
        option.selected = true;
      }
    });

    // Deactivate all other tabs
    this.deactivateTabs();

    activeTab.setAttribute('aria-selected', true);

    const activePanel = [...this.dom.$tabPanels].find(
      (panel) => panel.id === controls
    );

    activePanel.hidden = false;
    loadAsyncModules(activePanel);
  }

  deactivateTabs() {
    this.dom.$tabs.forEach((tab) => tab.setAttribute('aria-selected', false));

    this.dom.$tabPanels.forEach((panel) => {
      panel.hidden = true;
    });
  }

  setRovings() {
    rovingIndex({
      element: this.dom.$tabContainer,
      target: '.tabbed-content__tab',
      callback: (el) => {
        this.activateTab(el.id);
      }
    });
  }
}

export default Module;
